import Section from '@widgets/components/section';
import { Table, TableBody, TableTd, TableTh, TableThead, TableTr } from '@widgets/table';
import { formatNum } from '@app/utils/math';
import { Loader } from '@shared/uikit/loader';
import { useMemo } from 'react';
import clsx from 'clsx';
import { LeaderCell } from './leader-cell';
import { TextSize, Typography } from '@shared/index';
import { useGetManagerQuarterlyBonus } from '@entities/managers-perfomance';

type Props = {
  year: number;
  quarter: number;
};

export const QuarterlyBonusTable = ({ year, quarter }: Props) => {
  const { data: quarterlyBonus, isLoading } = useGetManagerQuarterlyBonus({ year, quarter });

  const tableData = useMemo(() => {
    if (!quarterlyBonus) return [];

    return quarterlyBonus.map(
      ({ place, manager_name, grade, hashrate, difference_from_leader, manager_id }) => ({
        place,
        name: manager_name,
        position: grade,
        hashrate,
        gapFromFirst: difference_from_leader,
        isLeader: place === 1 || difference_from_leader === 0,
        managerId: manager_id,
      })
    );
  }, [quarterlyBonus]);

  if (isLoading) {
    return (
      <Section>
        <Loader loading={true} />
      </Section>
    );
  }

  return (
    <Section>
      <Typography
        size={TextSize.size24}
        title="Места в квартальном бонусе"
        className="font-semibold mb-3"
      />
      <div className="overflow-y-auto max-h-[280px]">
        <Table>
          <TableThead className="text-white/40 [&_div]:justify-start">
            <TableTr withoutUnderline>
              <TableTh title="Место" className="w-[10%]" />
              <TableTh title="Имя" className="w-[25%]" />
              <TableTh title="Должность" className="w-[25%]" />
              <TableTh title="Хешрейт (Ph)" className="w-[20%]" />
              <TableTh title="Отрыв от 1го места (Ph)" className="w-[20%]" />
            </TableTr>
          </TableThead>
          <TableBody>
            {tableData.map((item, index) => {
              const isOdd = index % 2 === 0;

              return (
                <TableTr
                  key={item.managerId}
                  style={{ backgroundColor: isOdd ? '#1D1D1D' : 'unset' }}
                  withoutUnderline
                >
                  <TableTd
                    title={item.place.toString()}
                    className={clsx(isOdd && 'rounded-l-[16px]')}
                  />
                  <TableTd
                    title={
                      <div className="flex items-center gap-2">
                        <span className={item.isLeader ? 'font-semibold' : ''}>{item.name}</span>
                      </div>
                    }
                  />
                  <TableTd title={item.position} />
                  <TableTd title={`${formatNum(item.hashrate)}`} />
                  <TableTd
                    title={<LeaderCell gapFromFirst={item.gapFromFirst} isLeader={item.isLeader} />}
                    className={clsx(isOdd && 'rounded-r-[16px]')}
                  />
                </TableTr>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </Section>
  );
};
